import React, { useEffect, useState } from 'react'
import { IoIosArrowDroprightCircle } from 'react-icons/io'
import { url, wpsDiscountMessageCorps } from '../configlink';
import { useDispatch } from 'react-redux';
import { setDcssOrderDiscount, setHtpOrderDiscount, setSppeOrderDiscount, setWpsOrderDiscount } from '../store';

export const Bill = ({type, price, changePrice, page, user, wpsDiscount, numOfrxns}) => {

    let [couponCode, setCouponCode] = useState('')
    const [errors, setErrors] = useState({});
    let [showDiscount, setShowDiscount] = useState(false)
    let [totalPrice, setTotalPrice] = useState(0)
    let [userCheck, setUserCheck] = useState('')

    let dispatch = useDispatch()

    useEffect(() => {
        setTotalPrice(price)
    }, [price])

    useEffect(() => {
        setUserCheck({
            userId: user.UserId,
            userCorp: user.CorporateId
        })
    }, [user])

    let [showWpsDiscount, setShowWpsDiscount] = useState(false)

    useEffect(() => {
        if(wpsDiscount !== null && type === 'SPPE'){
            setShowWpsDiscount(true)
            setTotalPrice(Number(price) - Number(wpsDiscount))
            dispatch(setSppeOrderDiscount(1))
        } else{
            setShowWpsDiscount(false)
        }
    }, [wpsDiscount])  //sanger validation


    function validateDiscount(){
        let newErrors = {}

		if((type==='SPPE' || type === 'DCSS' || type === 'HTP') && couponCode.toLowerCase().includes('wps')) newErrors.wrongCoupon = 'Wrong Coupon'
        
        // if(type === 'WPS' && !couponCode.toLowerCase().includes('wps20')) newErrors.wrongCoupon = 'Wrong Coupon'
		
		if(couponCode.toLowerCase() === '10wps50' && type === 'WPS' ) {
			// if(wpsDiscountMessageCorps.includes(user.CorporateId) && Number(numOfrxns) < 10){
			// 	newErrors.wrongCoupon = 'multiple10'
			// } else if(!wpsDiscountMessageCorps.includes(user.CorporateId)) {
			// 	newErrors.wrongCoupon = 'Wrong Coupon'
			// }
			
			if(Number(numOfrxns) < 10){
				newErrors.wrongCoupon = 'multiple10'
			}
		}
		
		
        return newErrors
    }


    function checkCouponCode(){

        let validate = validateDiscount()

		if(couponCode === '') {
					setErrors({
						...errors,
						couponCode: 'Please enter the code'
					})
		}
		else if(Object.keys(validate).length > 0){
            setErrors({
                        ...errors,
						couponCode: validate.wrongCoupon === 'multiple10'? 'This discount code is applicable only for 10 or more reactions.' : 'This code is invalid'
                    })
        }
        else {

            let body3 = {
            coupon: couponCode,
            user: userCheck
			}

        try {
            fetch(`${url}/api/users/check_discount`, {
                method:"POST",
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body3)
            })
            .then(res => res.json())
            .then(data => {
                // console.log(data);

                if(data.message === 'invalid'){
                    setErrors({
                        ...errors,
                        couponCode: 'This code is invalid'
                    })
                }
                else if(data.message === 'used'){
                    setErrors({
                        ...errors,
                        couponCode: 'This code has been used previously.'
                    })
                }
                else if(data.message === 'success'){
                    setErrors({
                        ...errors,
                        couponCode: 'Applied Successfully!'
                    })


                    // if(data.disCode.includes('WPS20_')){
                    //     // alert("YES")
                    //     let disVal2 = parseFloat(price)*(data.disVal/100) > 20 ? 20 : parseFloat(price)*(data.disVal/100)
                    //     setShowDiscount({bool:true, message:`-${data.disVal}% or up to $20 off`, value: disVal2})
                    //     calculateTotal(3, price, disVal2)
                    // }
                    // else {
                    //     if(data.disType === 2){
                    //         let disVal2 = parseFloat(price)*(data.disVal/100)
                    //         setShowDiscount({bool:true, message:`-${data.disVal}%`, value: disVal2})
                    //         calculateTotal(data.disType, price, parseFloat(data.disVal))
                    //     }
                    //     else {
                    //         // let disVal2 = parseFloat(price)*(data.disVal/100)
                    //         setShowDiscount({bool:true, message:`-$${data.disVal} Off`, value: data.disVal})
                    //         calculateTotal(data.disType, price, parseFloat(data.disVal))
                    //     }
                    // }

                    if(data.disType === 2){
                        let disVal2 = parseFloat(price)*(data.disVal/100)
                        let disUpto2 = Number(data.disUpto)
                        
                        if(disUpto2 > 0){
                            let pickVal = Math.min(disVal2, disUpto2)
                            setShowDiscount({bool:true, message:`-${data.disVal}% or up to $${disUpto2} off`, value: pickVal})
                            calculateTotal(3, price, pickVal)
                        }
                        else {
                            setShowDiscount({bool:true, message:`-${data.disVal}%`, value: disVal2})
                            calculateTotal(data.disType, price, parseFloat(data.disVal))
                        }
                    }
                    else {
                        // let disVal2 = parseFloat(price)*(data.disVal/100)
                        setShowDiscount({bool:true, message:`-$${data.disVal} Off`, value: data.disVal})
                        calculateTotal(data.disType, price, parseFloat(data.disVal))
                    }

                    if(type === 'SPPE'){
                        dispatch(setSppeOrderDiscount(data.disId))
                    }
                    else if(type === 'DCSS'){
                        dispatch(setDcssOrderDiscount(data.disId))
                    }
                    else if(type === 'HTP'){
                        dispatch(setHtpOrderDiscount(data.disId))
                    }
                    else if(type === 'WPS'){
                        dispatch(setWpsOrderDiscount(data.disId))
                    }

                    // setTimeout(() => {
                    //     setCouponCode('')
                    //     setErrors({
                    //         ...errors,
                    //         couponCode: ''
                    //     })
                    // }, 15000)
                }
            })
        } catch (error) {
            console.log(error);
            
        }

        }
        
        
        
      }


      function calculateTotal(type, x, y){
        if(type === 3){
            let price = parseFloat(x)
            let tot = price - parseFloat(y)
            setTotalPrice(tot)
            changePrice(tot)
        }
        else if(type === 2){
            let price = parseFloat(x)
            let discount = parseFloat(y)/100
        
            let tot = price - price*discount
            setTotalPrice(tot)
            changePrice(tot)
        }
        else {
            let price = parseFloat(x)
            let discount = parseFloat(y)
        
            let tot = price - discount
            setTotalPrice(tot)
            changePrice(tot)

        }
      }

  return (
    <div className='mt-5 px-8 py-4'>
        <div className='flex items-start justify-between gap-[30px]'>
            {page==='billing' && !wpsDiscount && 
                <div className=" w-[50%] pl-3 flex flex-col">
                    <label className='xl:text-lg  font-black text-[var(--color-primary-purple)] mb-3'>
                    Discount Code <span className='font-normal text-gray-600'>(Optional)</span>
                    </label>
                    <div className="flex">
                    <input 
                    type="text" 
                    className="h-10 border-2 border-[var(--color-primary-purple)] w-full max-w-[300px] px-2"
                    value={couponCode}
                    onChange={(e) => {
                    setErrors({
                        ...errors,
                        couponCode:''
                    })
                    setCouponCode(e.target.value)
                    }}
                    />
                    {/* <button
                        id='addTrial'
                        onClick={() => {
                        checkCouponCode()
                        }}
                        className='text-4xl text-[var(--color-primary-purple)] pl-4'
                    >
                        <IoIosArrowDroprightCircle />
                    </button> */}
                    <button
                        id='addTrial'
                        onClick={() => {
                        checkCouponCode()
                        }}
                        className='ml-4 rounded-md text-lg h-10 bg-[var(--color-primary-purple)] px-4 text-white'
                    >
                        Apply
                    </button>
                    </div>
                    {errors.couponCode && (
                        <p className={`text-[14px] ${errors.couponCode.includes("Applied")?'text-green-600':'text-red-600'} font-bold mt-1`}>{errors.couponCode}</p>
                        )} 
                </div>  
            }
            <div className={`flex-1 flex ${page ==='billing'? 'justify-end':'justify-center'}`}>
                <div className='w-[550px] flex flex-col gap-[5px]'>
                    <div className='flex items-cemter justify-between text-lg'>
                        <p>Estimated Price</p>
                        <p>${parseFloat(price).toFixed(2)}</p>
                    </div>
                    {showWpsDiscount &&
                        <div className='text-red-500 flex items-cemter justify-between text-lg'>
                            <p>Discount (WPS)</p>
                            <p className='text-red-500'>- ${parseFloat(wpsDiscount).toFixed(2)}</p>
                        </div>
                    }
                    {showDiscount.bool === true && 
                        <div className='text-red-500 flex items-cemter justify-between text-lg'>
                            <p>Discount ({showDiscount.message})</p>
                            <p className='text-red-500'>- ${parseFloat(showDiscount.value).toFixed(2)}</p>
                        </div>
                    }
                    <hr/>
                    <div className='flex items-cemter justify-between text-lg'>
                        <p className='font-bold text-xl text-[var(--color-primary-purple)]'>ESTIMATED TOTAL</p>
                        <p className='font-bold text-xl text-[var(--color-primary-purple)]'>${parseFloat(totalPrice).toFixed(2)}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
